import Header from "@/components/app/Header";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-3xl mx-auto px-5 md:px-8 pt-10 md:pt-14 pb-20" data-testid="privacy-page">
        <div className="overline mb-3">Informativa</div>
        <h1 className="font-display text-3xl sm:text-4xl font-light text-[#1A231F]">Informativa sulla Privacy</h1>
        <p className="mt-3 text-sm text-[#5C7066]">Ultimo aggiornamento: 26 Febbraio 2026</p>

        <div className="prose prose-sm max-w-none mt-10 text-[#3A4A42] leading-relaxed space-y-6">
          <p>
            La presente Informativa descrive le modalità di trattamento dei dati personali degli utenti che
            utilizzano il servizio di prenotazione online disponibile su <strong>prenota.lucaderobertis.it</strong>{" "}
            (di seguito "Sito"), ai sensi del Regolamento (UE) 2016/679 ("GDPR") e del D.Lgs. 196/2003 e s.m.i.
          </p>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">1. Titolare del trattamento</h2>
            <p>
              Il Titolare del trattamento è il <strong>Dott. Luca DeRobertis</strong>, Osteopata e
              Fisioterapista, con sede legale in <strong>Via Valsolda, Milano</strong>.
              <br />
              P.IVA: <strong>03232340830</strong>
              <br />
              Iscrizione albo FNOFI n. <strong>5427</strong>
              <br />
              Email di contatto per richieste privacy:{" "}
              <a href="mailto:lucaderobertis@gmail.com" className="text-[#2D4A3E] underline">
                lucaderobertis@gmail.com
              </a>
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">2. Dati personali raccolti</h2>
            <p>Durante la prenotazione online raccogliamo i seguenti dati:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Dati anagrafici: nome e cognome</li>
              <li>Dati di contatto: indirizzo email, numero di telefono</li>
              <li>Dati relativi all'appuntamento: sede, tipologia di trattamento, data e orario</li>
              <li>Motivo della visita e note facoltative fornite dall'utente</li>
              <li>Dati tecnici di navigazione (indirizzo IP, tipo di browser, timestamp), raccolti automaticamente</li>
            </ul>
            <p className="mt-2">
              Non vengono raccolti dati particolari relativi allo stato di salute in fase di prenotazione. Eventuali
              informazioni cliniche saranno trattate esclusivamente in sede di visita e conservate secondo la normativa
              sanitaria applicabile.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">3. Finalità e base giuridica</h2>
            <p>I dati raccolti sono trattati per le seguenti finalità:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>
                <strong>Gestione della prenotazione</strong> e conferma dell'appuntamento — base giuridica: esecuzione di
                un contratto (art. 6.1.b GDPR)
              </li>
              <li>
                <strong>Invio di comunicazioni via email</strong> (conferma, promemoria 24h prima, eventuali modifiche o
                cancellazioni) — base giuridica: esecuzione contrattuale
              </li>
              <li>
                <strong>Sincronizzazione con Google Calendar</strong> del professionista per la gestione degli
                appuntamenti — base giuridica: legittimo interesse organizzativo (art. 6.1.f GDPR)
              </li>
              <li>
                <strong>Adempimenti amministrativi, contabili e fiscali</strong> — base giuridica: obbligo di legge (art.
                6.1.c GDPR)
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">4. Destinatari e terze parti</h2>
            <p>
              I dati non sono oggetto di diffusione. Possono essere condivisi, esclusivamente per le finalità sopra
              indicate, con i seguenti soggetti in qualità di Responsabili del trattamento:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>
                <strong>Google LLC</strong> — servizio Google Calendar per la sincronizzazione degli appuntamenti (
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#2D4A3E] underline"
                >
                  privacy policy
                </a>
                )
              </li>
              <li>
                <strong>Resend Inc.</strong> — provider per l'invio di email transazionali di conferma e promemoria (
                <a
                  href="https://resend.com/legal/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#2D4A3E] underline"
                >
                  privacy policy
                </a>
                )
              </li>
              <li>
                <strong>MongoDB Atlas</strong> — servizio di database cloud per l'archiviazione dei dati di prenotazione
              </li>
              <li>Consulenti tecnici, amministrativi e fiscali del Titolare, se richiesto</li>
            </ul>
            <p className="mt-2">
              Alcuni fornitori possono operare al di fuori dello Spazio Economico Europeo. In tali casi, il
              trasferimento avviene sulla base di garanzie adeguate previste dal GDPR (Clausole Contrattuali Standard).
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">5. Periodo di conservazione</h2>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Dati di prenotazione: conservati per <strong>10 anni</strong> come da normativa sanitaria e fiscale</li>
              <li>Log tecnici di navigazione: conservati per un massimo di <strong>12 mesi</strong></li>
              <li>Dati per adempimenti fiscali: <strong>10 anni</strong> ai sensi del Codice Civile</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">6. Diritti dell'interessato</h2>
            <p>Ai sensi degli articoli 15-22 GDPR, l'utente ha diritto in qualsiasi momento a:</p>
            <ul className="list-disc pl-6 space-y-1 mt-2">
              <li>Accedere ai propri dati personali</li>
              <li>Ottenere la rettifica o cancellazione dei dati</li>
              <li>Ottenere la limitazione del trattamento</li>
              <li>Opporsi al trattamento</li>
              <li>Richiedere la portabilità dei dati</li>
              <li>Revocare il consenso in qualsiasi momento (ove applicabile)</li>
              <li>
                Proporre reclamo all'Autorità Garante per la protezione dei dati personali (
                <a
                  href="https://www.garanteprivacy.it"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[#2D4A3E] underline"
                >
                  www.garanteprivacy.it
                </a>
                )
              </li>
            </ul>
            <p className="mt-2">
              Per esercitare tali diritti è sufficiente scrivere a{" "}
              <a href="mailto:lucaderobertis@gmail.com" className="text-[#2D4A3E] underline">
                lucaderobertis@gmail.com
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">7. Sicurezza dei dati</h2>
            <p>
              Adottiamo misure tecniche e organizzative adeguate per proteggere i dati da accessi non autorizzati,
              perdita o divulgazione: connessione crittografata HTTPS/TLS, autenticazione forte per l'area riservata,
              backup periodici e accesso limitato al solo Titolare.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">8. Cookie</h2>
            <p>
              Il Sito utilizza esclusivamente cookie tecnici necessari al corretto funzionamento della piattaforma
              (mantenimento della sessione, memorizzazione delle preferenze). Non vengono utilizzati cookie di
              profilazione o di terze parti a fini pubblicitari.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#1A231F] mt-8 mb-3">9. Modifiche</h2>
            <p>
              Il Titolare si riserva il diritto di aggiornare la presente Informativa in qualsiasi momento. La versione
              in vigore è sempre pubblicata su questa pagina con l'indicazione della data di ultimo aggiornamento.
            </p>
          </section>
        </div>

        <div className="mt-14 pt-6 border-t border-[#2D4A3E]/10 text-sm text-[#5C7066]">
          <Link to="/" data-testid="privacy-back-link" className="text-[#2D4A3E] hover:underline">
            ← Torna alla home
          </Link>
        </div>
      </main>
    </div>
  );
}
